import { axiosPut } from 'shared/api/axios'
import { AxiosError } from 'axios'
import { apiUrls } from 'consts'
import displayGenError from 'shared/utils/displayGenError'
import setFormValidationError from 'shared/utils/setFormValidationError'

interface submitFormProps {
  data: any
  setShowOverlay: Function
  setError: Function
  id: string | undefined
}

const submitForm = async (props: submitFormProps) => {
  let response: any = false
  props.setShowOverlay(true)
  props.data['country_id'] = props.data.country?.id ?? ''
  props.data['state_id'] = props.data.state?.id ?? ''
  props.data['primary_contact_user_id'] = props.data.primaryContact?.id ?? ''

  const formData = {
    ...props.data,
  }

  response = await axiosPut(
    apiUrls.customers + '/' + apiUrls.actionMyCustomer,
    formData,
    (err: AxiosError) => {
      if (err.response!.status === 422) {
        let mappedAttributes: Map<string, string> = new Map()
        mappedAttributes.set('primary_contact_user_id', 'primaryContact')
        mappedAttributes.set('country_id', 'country')
        mappedAttributes.set('state_id', 'state')
        mappedAttributes.set('city', 'city')
        setFormValidationError(err, props.setError, mappedAttributes, 'name')
      } else {
        displayGenError({ setShowOverlay: props.setShowOverlay })
      }
      props.setShowOverlay(false)
    },
  )

  return response
}

export default submitForm
